import { __callbacks } from "Utils/Callbacks/Callback";
import { ChatMessageFragment } from "Utils/Chats/ChatMessageFragment";
import { Chat } from "Utils/Enums";
import { IBotExMessage, IQuiz } from "Utils/Interfaces";
import { useCallback, useState } from "react";
import CustomLayout from "../CustomLayout/CustomLayout";
import styles from "./Quiz.module.scss";

export default function Quiz(props: IQuiz) {

    const [classDisable, setClassDisable] = useState<string>(props.disable ? styles.disable : "");
    const [options,] = useState<IBotExMessage[]>(props.quiz.options);

    const handleUpdate = useCallback(
        () => {
            __callbacks.msgUpdate.trigger(
                {
                    type: Chat.Fragment,
                    data: new ChatMessageFragment({
                        id: props.id,
                        chatId: props.conversationId,
                        messageNo: props.messageNo,
                        messageType: props.messageType,
                        fragmentType: "Quiz",
                        time: Date.now(),
                        props: {
                            ...props,
                            disable: true
                        }
                    })
                }
            );
        },
        [props],
    );

    const onClickOption = (option: IBotExMessage) => {
        // disable the quiz
        setClassDisable(styles.disable);
        handleUpdate();
        setTimeout(() => {
            __callbacks.chatInputSubmit.trigger({
                textAreaValue: option.value
            });
            __callbacks.userResponse.trigger(option.id);
        }, 200);
    }

    return (
        <CustomLayout>
            <div className={`${styles.container} ${classDisable}`}>
                <div className={styles["title"]}>{props.quiz.title}</div>
                {
                    options.map((option, index) => {
                        if (typeof option.value === "string") {
                            return <div key={index} onClick={() => { onClickOption(option) }} className={styles["option"]}>{option.value}</div>
                        }
                        else return <></>
                    })
                }
            </div>
        </CustomLayout>
    )
}
